import { AppStats } from "../actions";

const initialState = {
  stats: {},
  newPolicies: {
    totalPages: 0,
    docs: [],
  },
  orderedPolicies: {
    totalPages: 0,
    docs: [],
  },
  installments: {
    totalPages: 0,
    docs: [],
  },
  paidFines: {
    totalPages: 0,
    docs: [],
  },
  claims: {
    totalPages: 0,
    docs: [],
  },
  costs: {
    totalPages: 0,
    docs: [],
  },
  events: {
    totalPages: 0,
    docs: [],
  },
  geoWash: {
    totalPages: 0,
    docs: [],
  },
  dashcam: {
    totalPages: 0,
    docs: [],
  },
  dashcamPurchases: {
    totalPages: 0,
    docs: [],
  },
  dashcamPublishedReports: {
    totalPages: 0,
    docs: [],
  },
  averageSpeed: {
    totalPages: 0,
    docs: [],
  },
};

const handleNewDocs = (state, payload, key) => {
  const page = payload.page ?? payload.pageNumber ?? 1;
  const docs = payload.docs || [];
  if (page === 1) return docs;
  const _docs = docs.filter(
    (newDoc) => !state[key].docs.find((oldDoc) => newDoc._id === oldDoc._id)
  );
  return [...state?.[key]?.docs, ..._docs];
};

const app = (state = initialState, { type, payload, key } = {}) => {
  switch (type) {
    case AppStats.GET_STATS_SUCCESS:
      return {
        ...state,
        stats: { ...state.stats, ...payload },
      };
    case AppStats.GET_INFO_SUCCESS:
      return {
        ...state,
        [key]: {
          totalPages: payload.totalPages,
          docs: handleNewDocs(state, payload, key),
        },
      };
    default:
      return state;
  }
};

export default app;
